var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdiChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.58984 15.58L13.1698 11L8.58984 6.41L9.99984 5L15.9998 11L9.99984 17L8.58984 15.58Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiChevronRight);
export default __webpack_public_path__ + "static/media/mdi_chevron-right.73cf9dc100807dd7fe2fd435eb3f6d37.svg";
export { ForwardRef as ReactComponent };